import colors from 'vuetify/lib/util/colors'

let themeConfig = {
    dark: false,
    colors: {
        primary: '#322b80',
        secondary: '#808080',
        accent: '#009de0',
        error: colors.red.base,
        info: colors.blue.base,
        success: colors.green.base,
        warning: colors.yellow.base,
    },
}

export default themeConfig;